import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const EthereumIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { d: "M7.999 0v.001l5.248 8.15-.003.001.003.001-5.249 2.904L2.75 8.153h.003L2.75 8.15 7.997.003 7.998 0Z", fill: "currentColor" }),
        React.createElement("path", { d: "m2.75 9.078 5.248 2.902 5.252-2.902-5.251 6.92V16L2.75 9.078Z", fill: "currentColor" })));
});
EthereumIcon.displayName = 'EthereumIcon';
export default EthereumIcon;
